import { css } from '@/styled-system/css';

export const formFieldStyles = css.raw({
  '& > [data-c11n-component="Label"]': {
    display: 'block',
    marginBlockEnd: 'FormField.gap.field-toLabelArea',
  },

  '& > [data-c11n-component="FormHelp"]': {
    marginBlockStart: 'FormField.gap.field-toHelperArea',
  },
});
